import { createApi } from '@reduxjs/toolkit/query/react';

import { SCOPE_ASSESSOR_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export interface MemberDetails {
    memberId: string;
}

export const scopeAssessorApi = createApi({
    baseQuery: getBaseQuery(SCOPE_ASSESSOR_API_URL),
    reducerPath: 'scopeAssessorApi',
    endpoints: (build) => ({
        getMemberDetails: build.query<
            MemberDetails,
            {
                payerId: string;
                segmentId: string;
                memberId: string;
                firstName: string;
                lastName: string;
                dateOfBirth: string;
                raiseNotFound: boolean;
            }
        >({
            query: ({ payerId, segmentId, memberId, firstName, lastName, dateOfBirth }) => ({
                url: `${payerId}/members/${memberId}`,
                params: {
                    segment_id: segmentId,
                    firstname: firstName,
                    lastname: lastName,
                    dateofbirth: dateOfBirth,
                    ignore_dates: true,
                },
            }),
            transformResponse: (member: { member_id: string }) => ({
                memberId: member.member_id,
            }),
            transformErrorResponse: (err, _, { raiseNotFound = true }) => {
                if (err.status === 404) {
                    if (raiseNotFound) {
                        return handleError('Member not found.', err);
                    }
                    return err;
                }
                return handleError('An error occurred retrieving member details.', err);
            },
        }),
    }),
});

export const { useGetMemberDetailsQuery } = scopeAssessorApi;
